import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import classList from 'flarum/common/utils/classList';
import chatState from '../state/chat';
import { loadChatUi } from '../utils/lazy';
import { isNarrowViewport } from '../utils/surface';
import { morphIn } from '../utils/morph';
let panel = null;
let pending = null;

/**
 * Baixa o painel do drawer, que fica no chunk lazy da interface. Chamadas
 * simultâneas viram uma só.
 */
export function loadDrawerPanel() {
  pending != null ? pending : pending = loadChatUi().then(ui => {
    panel = ui.ChatDrawerPanel;
    m.redraw();
  }, error => {
    pending = null;
    throw error;
  });
  return pending;
}

/**
 * Casca do drawer que fica no bundle inicial. Fechado não desenha nada; aberto
 * antes do chunk chegar, mostra a caixa com spinner até o ChatDrawerPanel assumir.
 */
export default class ChatDrawer extends Component {
  constructor() {
    super(...arguments);
    /** Se a caixa provisória estava na tela no último render. */
    _defineProperty(this, "placeholderShown", false);
  }
  oncreate(vnode) {
    super.oncreate(vnode);
    this.morphPlaceholder(vnode.dom);
  }
  onupdate(vnode) {
    super.onupdate(vnode);
    this.morphPlaceholder(vnode.dom);
  }

  /**
   * Sem o chunk, é a caixa provisória que cresce a partir do botão; o painel que a
   * substitui entra sem repetir a animação.
   */
  morphPlaceholder(dom) {
    const box = dom instanceof HTMLElement && dom.classList.contains('ChatDrawer--loading') ? dom : null;
    if (box && !this.placeholderShown) morphIn(box, 'drawer');
    this.placeholderShown = box !== null;
  }
  view() {
    if (!chatState.drawerOpen) return null;
    if (panel) {
      const Panel = panel;
      return m(Panel, null);
    }
    loadDrawerPanel().catch(() => {});
    if (isNarrowViewport()) return null;
    return m("div", {
      className: classList('ChatDrawer ChatDrawer--loading', {
        'ChatDrawer--collapsed': chatState.drawerCollapsed
      }),
      role: "complementary",
      "aria-busy": "true"
    }, m(LoadingIndicator, null));
  }

  /**
   * Abre o drawer e carrega a lista de canais na primeira vez. O redraw vem antes
   * do carregamento para o drawer não esperar a ida e volta; a sidebar mostra o
   * skeleton enquanto isso.
   */
  static async open() {
    chatState.setDrawerOpen(true);
    chatState.setDrawerCollapsed(false);
    loadDrawerPanel().catch(() => {});
    m.redraw();
    if (chatState.channelsLoaded) return;
    await Promise.all([chatState.loadChannels(), chatState.loadDrafts()]).catch(() => {});
  }
}
flarum.reg.add('ramon-chat', 'forum/components/ChatDrawer', ChatDrawer);